import { ChangeDetectorRef, Component } from '@angular/core';
import { CardBodyComponent, CardComponent, CardHeaderComponent, ColComponent, ContainerComponent, FormModule, IColumn, RowComponent, SmartTableComponent, TemplateIdDirective } from '@coreui/angular-pro';
import { CommonModule, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChartjsComponent } from '@coreui/angular-chartjs';
import { DataTablesModule } from 'angular-datatables';
import { VehicleConsecutiveDays } from '../../../models/vehicle-consecutive-days.model';
import { VehicleConsecutiveDaysService } from '../../../services/vehicle-consecutive-days.service';
import { ActivatedRoute, Params, RouterLink } from '@angular/router';
import { concatMap, Subscription } from 'rxjs';
@Component({
  selector: 'app-depot-unutilised',
  standalone: true,
  imports: [ChartjsComponent, ContainerComponent, RowComponent, ColComponent, CardComponent, CardBodyComponent, CommonModule, CardHeaderComponent, DataTablesModule
    ,SmartTableComponent,
    TemplateIdDirective,
    RouterLink,
    FormModule
  ],
  templateUrl: './depot-unutilised.component.html',
  styleUrl: './depot-unutilised.component.scss'
})
export class DepotUnutilisedComponent {
  // repairerSummaryData = {
  //   labels: ["Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
  
  //   datasets: [
  //     {
  //       label: "Average number of days vehicle time spent at repairer",
  //       data: [4, 5, 6, 3, 8, 9], // Example data points for each month
  //       fill: false, // No fill under the line
  //       borderColor: "#4DB6AC", // Line color
  //       tension: 0.4, // Smoothing the line curve
  //       borderWidth: 3 // Thickness of the line
  //     }
  //   ]
  // };

  // repairerSummaryOptions = {
  //   scales: {
  //     y: {
  //       beginAtZero: true,
  //       max: 10,
  //       title: {
  //         display: true,
  //         text: "Days"
  //       }
  //     },
  //     x: {
  //       title: {
  //         display: true,
  //         text: "Months"
  //       }
  //     }
  //   },
  //   plugins: {
  //     legend: {
  //       display: false // Hides the legend to match the style in the image
  //     },
  //     tooltip: {
  //       enabled: true
  //     }
  //   }
  // };

  columns: IColumn[] = [
    {
      key: 'vehicle_registration',
      label: 'Registration',
      _style: { width: '20%' },
      _data: { tooltip: 'Date Registered', icon: 'cilCalendar' },
    },
    {
      key: 'vehicle_depot',
      label: 'Depot',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
    {
      key: 'unutilized_count',
      label: 'Unused Count',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
    {
      key: 'total_count',
      label: 'Total Count',
      _style: { width: '20%' },
      _labelTemplateId: 'all',
    },
  ];


  vehicleConsecutiveDaysData: VehicleConsecutiveDays[] = [];
  queryParams!: Params;
  queryParamsLength: number = 0;
  categories : any[] = []

  routeSubscription : Subscription | undefined;
  constructor(private vehicleConsecutiveDaysService: VehicleConsecutiveDaysService, private cdr: ChangeDetectorRef, private route: ActivatedRoute
  ) {}

  ngOnInit(): void {

    this.routeSubscription = this.route.queryParams
      .pipe(
        concatMap((queryParams: Params) => {
          this.queryParams = queryParams;
          this.queryParamsLength = Object.keys(this.queryParams).length
          console.log(this.queryParams);
          return this.route.parent?.params as any;
        })
      )
      .subscribe((res: any) => {
        this.onRouteChange(res)
      });



    if((Object.keys(this.queryParams).length === 0))
      this.routeSubscription = this.route.parent?.params.subscribe(
        (res: Params) => this.onRouteChange(res)
      ); 
    
  }



  onRouteChange(params: Params)
  {
    console.log(params)
    let _params = {'depot_id': params['depotId']}

    if(!(Object.keys(this.queryParams).length === 0)){
      _params = {..._params, ...this.queryParams} 
    }
    else{
      _params = {..._params, ...this.getLast30Days()}
      console.log(_params)

    }


    this.vehicleConsecutiveDaysService.getVehicleConsecutiveDays(_params).pipe(concatMap((data) => {
      this.vehicleConsecutiveDaysData= data;
      this.cdr.detectChanges();
      return this.vehicleConsecutiveDaysService.getVehicleCategories() as any
    })).subscribe((categories : any)=> {
      console.log(categories)
      this.categories = categories;
      this.cdr.detectChanges();

    })
  }

  handleChartRef($chartRef: any) {
    if ($chartRef) {
      setTimeout(() => {
        $chartRef?.update();
      }, 3000);
    }
  }


  getLast30Days(): { snapshot_date_start: string, snapshot_date_end: string } {
    const today = new Date();
    
    // Helper function to format the date as 'YYYY-MM-DD'
    function formatDate(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  
    // Get the end date (today)
    const snapshot_date_end = formatDate(today);
    
    // Get the start date by subtracting 30 days
    const snapshot_date_start = new Date(today);
    // Subtracting 29 days, because both start and end dates are included in backend filtering
    snapshot_date_start.setDate(today.getDate() - 29); // Subtract 29 days
    
    // Format the start date
    const formatted_snapshot_date_start = formatDate(snapshot_date_start);
  
    return { snapshot_date_start: formatted_snapshot_date_start, snapshot_date_end };
  }
  

}
